import React from 'react'
import { Form, Input } from 'antd'

export const AddressStep: React.FC = () => {
    return (
        <div style={{ maxWidth: 600, margin: '0 auto' }}>
            <Form.Item
                label="Street Address"
                name="address_line1"
                rules={[{ required: true, message: 'Please enter street address' }]}
            >
                <Input.TextArea rows={3} placeholder="Enter building, street, area" />
            </Form.Item>

            <Form.Item
                label="City"
                name="city"
                rules={[{ required: true, message: 'Please enter city' }]}
            >
                <Input placeholder="Enter city" />
            </Form.Item>

            <Form.Item
                label="State"
                name="state"
                rules={[{ required: true, message: 'Please enter state' }]}
            >
                <Input placeholder="Enter state" />
            </Form.Item>

            <Form.Item
                label="Pincode"
                name="pincode"
                rules={[
                    { required: true, message: 'Please enter pincode' },
                    { pattern: /^[1-9][0-9]{5}$/, message: 'Please enter a valid 6-digit Indian pincode' }
                ]}
            >
                <Input placeholder="600001" maxLength={6} />
            </Form.Item>

            <div style={{ display: 'flex', gap: '16px' }}>
                <Form.Item
                    label="Latitude"
                    name="latitude"
                    style={{ flex: 1 }}
                    rules={[{ required: true, message: 'Please enter latitude' }]}
                >
                    <Input placeholder="12.9716" />
                </Form.Item>

                <Form.Item
                    label="Longitude"
                    name="longitude"
                    style={{ flex: 1 }}
                    rules={[{ required: true, message: 'Please enter longitude' }]}
                >
                    <Input placeholder="77.5946" />
                </Form.Item>
            </div>
        </div>
    )
}
